
























import {
	defineComponent,
	PropType,
} from '@vue/composition-api';
import { PageProgress } from '@front-app/store/singletons/PageProgress';
import { useAsyncStatusDeprecated, useIsLoading } from '@front-app/hooks/useAsyncStatus';
import { fromWeightedPromises } from '@front-app/store/modules/progressBar';
import { EventsStore } from '@front-app/store/singletons/Events';
import ColumnHeader from '@front-app/components/layouts/columns/ColumnHeader.vue';
import ColumnContainer from '@front-app/components/layouts/columns/ColumnContainer.vue';
import ScrollingColumn from '@front-app/components/layouts/columns/ScrollingColumn.vue';
import SortedFilteredEventList from '@front-app/components/event/SortedFilteredEventList.vue';
import { BannerLocation } from '@front-app/services/ActionApi/UserActionRequestModel';
import {
	DEFAULT_EVENT_FILTERS,
	EventFilter,
} from './events/EventEnum';

const HEADER_OFFSET_ELEMENTS = [
	'.page-header__wrapper',
];

export default defineComponent({
	components: {
		ColumnHeader,
		ColumnContainer,
		ScrollingColumn,
		SortedFilteredEventList,
	},
	props: {
		currentAccessFilters: {
			type: Array as PropType<EventFilter[]>,
			default: DEFAULT_EVENT_FILTERS,
		},
		currentTypeFilters: {
			type: Array as PropType<string[]>,
			default: () => [],
		},
		currentTopicFilters: {
			type: Array as PropType<string[]>,
			default: () => [],
		},
	},
	setup() {
		const fetchEvents = EventsStore.getInstance()
			.getEventsOnce();

		const areEventsLoading = useIsLoading(useAsyncStatusDeprecated(fetchEvents));

		PageProgress.setProgress(fromWeightedPromises([
			{
				promise: fetchEvents,
				weight: 100,
			},
		]).progress);

		const { events } = EventsStore.getInstance();

		return {
			areEventsLoading,
			events,
			HEADER_OFFSET_ELEMENTS,
			BannerLocation,
		};
	},
});
